import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Radio } from '../../radio/Radio.js';
import styles from './Item.module.scss.js';

var Item = function (_a) {
    var inputProps = _a.inputProps, children = _a.children, className = _a.className, style = _a.style, disabled = _a.disabled;
    return (jsxs("label", __assign({ className: clsx(styles.item, className), style: style, htmlFor: String(inputProps.value) }, { children: [jsx(Radio, __assign({}, inputProps, { disabled: disabled })), jsx("span", __assign({ className: styles.label }, { children: children }))] })));
};

export { Item };
